// extracted by mini-css-extract-plugin
export default {"wrapper":"Xn-z","response":"Yn-z","error":"Zn-z","disabled":"_n-z","buttons":"ao-z","feedbackQuestionSection":"bo-z","yesNoWrapper":"co-z"};